import i18n from '../lib/i18n'

export const friendlyMessages = {
    'Txt description cannot be blank.': i18n.t(`Preview cannot be blank.`)
}